import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IDirectory, IDirectoryObj } from './types/Directory-interface';
import { fetchDirectory } from './actions/fetch-directory';

const initialState: IDirectory = {
    Priorities: [],
    Themes: [],
    isLoadingDirectory: false,
    errorDirectory: [],
    lastFetchTime: null
};

export const Directory = createSlice({
    name: 'Directory',
    initialState,
    reducers: {
        resetDirectory: (state) => {
            state.Priorities = [];
            state.Themes = [];
            state.isLoadingDirectory = false;
            state.errorDirectory = [];
            state.lastFetchTime = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchDirectory.pending, (state) => {
                state.isLoadingDirectory = true;
            })
            .addCase(fetchDirectory.fulfilled, (state, action: PayloadAction<{ themes: IDirectoryObj[], priorities: IDirectoryObj[], fetchTime: number }>) => {
                state.isLoadingDirectory = false;
                state.Priorities = action.payload.priorities;
                state.errorDirectory = [];
                state.lastFetchTime = action.payload.fetchTime;
                state.Themes = action.payload.themes;
            })
            .addCase(fetchDirectory.rejected, (state, action) => {
                state.Priorities = [];
                state.Themes = [];
                state.isLoadingDirectory = false;
                state.errorDirectory = action.payload as string[];
            });
    },
});

export const { resetDirectory } = Directory.actions;
export default Directory.reducer;